import React from "react";
import PropTypes from "prop-types";

const ChartLegend = ({ data }) => {
  return (
    <div className="panel-chart-legend">
      {data.map((legend, index) => (
        <div className={"donut-row"} key={index}>
          <span className="donut-row-color" style={{ background: legend.color }} />
          <span className="chart-legend-label">{legend.label}</span>
        </div>
      ))}
    </div>
  );
};

ChartLegend.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
    color: PropTypes.string,
    label: PropTypes.string,
  })),
};

export default ChartLegend;
